import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { useHistory, useLocation } from "react-router-dom";

interface StaticsProps {
    current: string;
    onChange: (current: string) => void;
    exerciseAllCount: string;
    noJudgeCount: string;
    judgeCount: string;
    noJoinInExerciseCount: string;
}

export default function Statics({
    current,
    onChange,
    exerciseAllCount,
    noJudgeCount,
    judgeCount,
    noJoinInExerciseCount
}: StaticsProps) {
    const history = useHistory();
    const { pathname } = useLocation();

    function handleClick(params: string) {
        onChange(params);
        history.replace(`${pathname}?status=${params}`);
    }

    return (
        <div className={style.root}>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "all"
                })}
                onClick={() => handleClick("all")}>
                <em>{exerciseAllCount || 0}</em>课程人数
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "noJudge"
                })}
                onClick={() => handleClick("noJudge")}>
                <em>{noJudgeCount || 0}</em>待批阅
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "judgeCount"
                })}
                onClick={() => handleClick("judgeCount")}>
                <em>{judgeCount || 0}</em>已批阅
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "noJoinIn"
                })}
                onClick={() => handleClick("noJoinIn")}>
                <em>{noJoinInExerciseCount || 0}</em>未参与
            </div>
        </div>
    );
}
